import React from 'react';
import LoaderButton from '../../../components/LoaderButton';
import TreeView from '../../../components/treeView/TreeView';
import './FeatureFlags.css';
import DatacorLogoSpinner from '../../../components/datacorLogoSpinner/DatacorLogoSpinner';
import { Card, CardContent, CardActions, CardHeader } from '@mui/material';
import useFeatureFlags from '../hooks/useFeatureFlags';

const FeatureFlags = () => {
    const {
        isLoading,
        treeData,
        onCheckChange,
        canEditFeatureFlags,
        updateFeatureFlags,
        isUnchanged,
    } = useFeatureFlags();
    return !isLoading ? (
        <Card sx={{ width: '50%', margin: 'auto' }}>
            <CardHeader title="Feature Flags" />
            <CardContent>
                <div className="treeViewRow">
                    <TreeView
                        caption="Features"
                        dataSource={treeData}
                        onCheckChange={onCheckChange}
                        data-testid="featuresTree"
                    />
                </div>
            </CardContent>
            <CardActions>
                {canEditFeatureFlags ? (
                    <LoaderButton
                        isLoading={null}
                        variant="contained"
                        type="submit"
                        size="large"
                        color="primary"
                        onClick={() => updateFeatureFlags()}
                        disabled={isUnchanged}>
                        Update
                    </LoaderButton>
                ) : null}
            </CardActions>
        </Card>
    ) : (
        <DatacorLogoSpinner />
    );
};

export default FeatureFlags;
